import React from 'react';
import styled from 'styled-components';
import UserSocialInfoCardSkeleton from './UserSocialInfoCardSkeleton';

const SocialCardWrapper = styled.div`
  border-radius: 8px !important;
  padding: 0px !important;
  width: 100%;
  min-width: 400px;
  margin-bottom: 20px;
  background-color: #fff;
  .profile-area{
    width: 100%;
    height: 150px;
    border-radius: 8px 8px 0 0;
  }
  .belowImageArea{
    width: 100%;
    padding: 21px 21px 14px 21px;
  }
  .tweetContent {
    margin-top: 16px;
    width: 100%;
    max-width: 530px;
    height: 44px;
  }
  .tweetTime {
    width: 100%;
    max-width: 200px;
    height: 18px;
  }
  .tweetLikesAndOther {
    width: 100%;
    max-width: 250px;
    height: 18px;
  }
`;

type Props = {
  image?: boolean
} & typeof defaultProps;

const defaultProps = {
  image: false,
};

const SocialCardSkeleton = function SocialCardSkeleton(props: Props) {
  const {
    image,
  } = props;
  return (
    <SocialCardWrapper>
      {
        image ? (
          <div
            className="skeleton-box profile-area"
          />
        ) : null
      }
      <div className="belowImageArea">
        <UserSocialInfoCardSkeleton />
        <div className="skeleton-box tweetContent" />
        <div className="skeleton-box tweetTime" />
        <div className="skeleton-box tweetLikesAndOther" />
      </div>
    </SocialCardWrapper>
  );
};

SocialCardSkeleton.defaultProps = defaultProps;
export default SocialCardSkeleton;
